import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {BaseService} from 'src/app/services/base.service';
import * as firebase from 'firebase/app';
import * as models from 'src/app/business/chat/interface';
import {Subject} from 'rxjs';
import {environment} from 'src/environments/environment';
import {AngularFireDatabase} from "angularfire2/database";

@Injectable({
  providedIn: 'root'
})


export class ChatService extends BaseService {
  constructor(protected http: HttpClient, private db: AngularFireDatabase) {
    super(http);
  }
  private conversionSource = new Subject<any>();
  conversionSource$ = this.conversionSource.asObservable();

  private updateConversationSource = new Subject<any>();
  updateConversationSource$ = this.updateConversationSource.asObservable();

  private openTabUnread = new Subject<any>();
  openTabUnread$ = this.openTabUnread.asObservable();

  private changeTab = new Subject<any>();
  changeTab$ = this.changeTab.asObservable();


  getDataFireBaseUrl(){

  }



  // tslint:disable-next-line:variable-name
  getFirebaseToken(id_shop: any): Observable<any> {
    return this.get<any>(`/shops/${id_shop}/firebase-token`);
  }

  // tslint:disable-next-line:variable-name
  getProfile(user_id): Observable<any> {
    return this.get<any>('/accounts/' + user_id);
  }

  selectConversation(key) {
    this.conversionSource.next(key);
  }

  selectChangetab(key) {
    this.changeTab.next(key);
  }
  clearMessage() {
    this.openTabUnread.next('clear');
  }



}
